// Styles
import "@mdi/font/css/materialdesignicons.css";
import "vuetify/styles";

// Vuetify
import { createVuetify } from "vuetify";
import { VTreeview } from "vuetify/labs/VTreeview";

export default createVuetify({
  components: {
    VTreeview,
  },
});
// https://vuetifyjs.com/en/introduction/why-vuetify/#feature-guides
